import {useEffect, useMemo, useState} from "react";
import {Grid} from "@mui/material";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import MDBox from "../../../../components/MDBox";
import {urlSearchParams} from "../../../common/Utils";
import {useNavigate} from "react-router-dom";
import {useSearchParams} from "react-router-dom";

export default function CalendarEvents({events, renderEventContent, handleDatesSet, eventClick, eventTypesFilter, ageTypeFilter, parties}) {

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const toolbar = {
    left: 'prev,next',
    center: 'title',
    right: 'rightSideButton'
  };

  const showEvent = (_event) => {
    if (!parties && _event?.eventType?.specialEvent) {
      return false;
    }
    if (parties && !_event?.eventType?.specialEvent) {
      return false;
    }
    let show = (eventTypesFilter.length === 0 || eventTypesFilter.indexOf(_event?.eventType?.id) > -1);
    show = show && (ageTypeFilter.length === 0 || ageTypeFilter.indexOf(_event?.ageRange?.id) > -1);
    return show;
  };

  const filteredEvents = (events) => {
    let _events = [];
    for (let j in events) {
      if (showEvent(events[j])) {
        _events.push(events[j]);
      }
    }
    setEventsFiltered(_events);
  }

  const [eventsFiltered, setEventsFiltered] = useState();
  useEffect(()=>{
    filteredEvents(events);
  },[events])

  useEffect(()=>{
    filteredEvents(events);
  },[eventTypesFilter, ageTypeFilter]);

  const toggleListView = () => {

    if (parties) {
      navigate('/cx/parties' + (urlSearchParams('eventType', searchParams.get('eventType'), '?')));
    } else {
      navigate('/cx/' + (urlSearchParams('eventType', searchParams.get('eventType'), '?')));
    }
  }
  return (
    <MDBox>
      <Grid container spacing={3} my={2}>
        <Grid item xs={12} xl={12} >
          <FullCalendar
            customButtons={{
              rightSideButton: {
                text: 'List View',
                click: () => {
                  toggleListView();
                },
              },
            }}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView='dayGridMonth'
            height={'auto'}
            contentHeight={'auto'}
            weekends={true}
            eventContent={renderEventContent}
            datesSet={handleDatesSet}
            events={eventsFiltered}
            headerToolbar={toolbar}
            eventClick={eventClick}
          />
        </Grid>
      </Grid>
    </MDBox>
  )
}